'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { ImageWithFallback as Image } from '@/components/common/image-with-fallback'
import { useSearchParams } from 'next/navigation'
import { CSSProperties, useEffect } from 'react'
import styles from './marquee.module.css'

interface MarqueeProps {
  logo: string
  content: string[]
  className?: string
  logoStyle?: CSSProperties
  labelClassName?: string
  logoClassName?: string
}

export const Marquee = ({
  logo,
  content,
  className,
  logoStyle,
  labelClassName,
  logoClassName,
}: MarqueeProps) => {
  const searchParams = useSearchParams()
  const scrollToMarquee = searchParams?.get('scroll_to_marquee')

  //nếu url có tham số scroll_to_marquee=true thì scroll đến marquee
  useEffect(() => {
    if (scrollToMarquee === 'true') {
      const marqueeElement = document.getElementById('marquee')
      if (marqueeElement) {
        marqueeElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [scrollToMarquee])
  const renderContent = (text: string) => {
    if (!text.includes('™')) return text

    return text.split(/(™)/g).map((part, index) => {
      if (part === '™') {
        return (
          <sup
            key={index}
            className='ml-0.5 text-[0.6em] uppercase leading-none'
          >
            TM
          </sup>
        )
      }
      return part
    })
  }

  return (
    <section
      id='marquee'
      className={cn('bg-neutral-900', styles.marqueeContainer, className)}
    >
      <div className='container-full px-4 md:pl-12'>
        <div className='relative flex items-center'>
          <div className={cn('pr-4', logoClassName)}>
            <Image
              src={ImageHelper.getImageUrlCdn(logo)}
              alt='Logo'
              width={128}
              height={64}
              style={logoStyle}
              className='max-h-11 w-auto md:max-h-16'
            />
          </div>
          <div className={cn(styles.marqueeWrapper, 'pl-5')}>
            <div className={styles.marquee}>
              <div
                className={cn(
                  styles.marqueeContent,
                  'flex items-center whitespace-nowrap font-criteria text-lg uppercase text-light md:text-2xl',
                  labelClassName
                )}
              >
                {content.map((item, index) => (
                  <span
                    key={`item-${index}`}
                    className='inline-block px-5 md:px-10'
                  >
                    {renderContent(item)}
                  </span>
                ))}
              </div>
              <div
                className={cn(
                  styles.marqueeContent,
                  'flex items-center whitespace-nowrap font-criteria text-lg uppercase md:text-2xl',
                  labelClassName
                )}
                aria-hidden='true'
              >
                {content.map((item, index) => (
                  <span
                    key={`duplicate-${index}`}
                    className='inline-block px-5'
                  >
                    {renderContent(item)}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
